export default __webpack_public_path__ + "static/media/Q_Matting.8bba5e03.jpg";